import React from 'react';
import { Marker, InfoWindow } from 'react-google-maps';
import {
  controladorConectadoNoCadastro,
  podeResetarControlador,
  rotuloStatusConexao,
  textoAneisControlador,
} from './mapaControladorCadastro';

const CTRL_MAP_W = 20;
const CTRL_MAP_H = 32;

const URL_SEMAFORO_CACHE = { on: null, off: null };

function svgSemafaroControlador(conectado) {
  const luz = conectado ? '#16a34a' : '#6b7280';
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 52" width="32" height="52">
  <rect x="1" y="1" width="30" height="50" rx="9" fill="#cbd5e1" stroke="#94a3b8" stroke-width="2"/>
  <rect x="5" y="5" width="22" height="42" rx="6" fill="#1e293b"/>
  <circle cx="16" cy="15" r="4.2" fill="${luz}"/>
  <circle cx="16" cy="26" r="4.2" fill="${luz}"/>
  <circle cx="16" cy="37" r="4.2" fill="${luz}"/>
</svg>`;
}

function urlSemafaroControlador(conectado) {
  const key = conectado ? 'on' : 'off';
  if (!URL_SEMAFORO_CACHE[key]) {
    URL_SEMAFORO_CACHE[key] = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgSemafaroControlador(conectado))}`;
  }
  return URL_SEMAFORO_CACHE[key];
}

/** Semáforo vertical — 3 luzes verdes (conectado) ou cinzas (sem conexão), status do banco. */
export function iconeMarcadorControlador(controlador) {
  const conectado = controlador ? controladorConectadoNoCadastro(controlador) : false;
  const url = urlSemafaroControlador(conectado);
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    return {
      url,
      scaledSize: new window.google.maps.Size(CTRL_MAP_W, CTRL_MAP_H),
      anchor: new window.google.maps.Point(CTRL_MAP_W / 2, CTRL_MAP_H),
    };
  }
  return url;
}

/** @deprecated use iconeMarcadorControlador(controlador) */
export const PIN_CONTROLADOR = urlSemafaroControlador(false);

export function rotuloControlador(c) {
  const num =
    c.numero_controlador != null && c.numero_controlador !== ''
      ? c.numero_controlador
      : c.controlador_id;
  return `Controlador ${num}`;
}

export function subtituloControlador(c) {
  const cruz = c.cruzamento && String(c.cruzamento).trim();
  if (cruz) return cruz;
  const end = c.endereco && String(c.endereco).trim();
  return end || null;
}

/** @deprecated prefer rotuloStatusConexao */
export function statusCadastroControlador(c) {
  return rotuloStatusConexao(c).label;
}

/** Completa cadastro estático a partir da lista do grupo (ex.: item Waze só com id). */
export function mesclarCadastroControlador(c, lista) {
  if (!c || !lista || !lista.length) return c;
  const id = Number(c.controlador_id);
  const num = c.numero_controlador != null ? Number(c.numero_controlador) : null;
  const match =
    lista.find(x => Number(x.controlador_id) === id) ||
    (num != null ? lista.find(x => Number(x.numero_controlador) === num) : null);
  return match ? { ...match, ...c } : c;
}

export function chaveMarcadorControlador(c) {
  if (!c) return '';
  const g = c.grupo_fisico_id != null ? c.grupo_fisico_id : 0;
  const num =
    c.numero_controlador != null && c.numero_controlador !== '' ? c.numero_controlador : c.controlador_id;
  return `ctrl:${g}:${num}`;
}

function impactoDoControlador(map, c) {
  if (!map || !c) return null;
  const porId = map.get(Number(c.controlador_id));
  if (porId) return porId;
  if (c.numero_controlador != null && c.numero_controlador !== '') {
    return map.get(Number(c.numero_controlador));
  }
  return null;
}

function formatarIpPorta(c) {
  if (!c || !c.ip) return null;
  const porta = c.porta != null && c.porta !== '' ? c.porta : null;
  return porta ? `${c.ip}:${porta}` : c.ip;
}

export function MapaControladorInfoWindow({ controlador, onDetalhes, onReset }) {
  const titulo = rotuloControlador(controlador);
  const sub = subtituloControlador(controlador);
  const endereco = controlador.endereco && String(controlador.endereco).trim();
  const statusConexao = rotuloStatusConexao(controlador);
  const aneis = textoAneisControlador(controlador);
  const ipPorta = formatarIpPorta(controlador);
  const exibirReset = onReset && podeResetarControlador(controlador);

  return (
    <div className="mapa-fases-info-window mapa-controlador-info-window">
      <div className="mapa-fases-info-header">
        <div>
          <strong>{titulo}</strong>
          {sub ? <span className="mapa-controlador-info-sub">{sub}</span> : null}
        </div>
      </div>
      <div className="mapa-fases-info-body">
        <div className="mapa-controlador-info-dados">
          <div className={`mapa-controlador-info-row mapa-controlador-info-row--status ${statusConexao.css}`}>
            <strong>Status</strong>
            <span>{statusConexao.label}</span>
          </div>
          {endereco ? (
            <div className="mapa-controlador-info-row">
              <strong>Endereço</strong>
              <span>{endereco}</span>
            </div>
          ) : null}
          {aneis ? (
            <div className="mapa-controlador-info-row">
              <strong>Anéis</strong>
              <span>{aneis}</span>
            </div>
          ) : null}
          {controlador.numero_fases != null ? (
            <div className="mapa-controlador-info-row">
              <strong>Fases</strong>
              <span>
                {controlador.numero_fases}
                {controlador.numero_fases_fim != null && controlador.numero_fases_fim !== controlador.numero_fases
                  ? ` a ${controlador.numero_fases_fim}`
                  : ''}
              </span>
            </div>
          ) : null}
          {ipPorta ? (
            <div className="mapa-controlador-info-row is-muted">
              <strong>IP</strong>
              <span>{ipPorta}</span>
            </div>
          ) : null}
        </div>
        {onDetalhes || exibirReset ? (
          <div className="mapa-controlador-info-acoes">
            {onDetalhes ? (
              <button type="button" className="mapa-controlador-info-detalhes-btn" onClick={onDetalhes}>
                Detalhes →
              </button>
            ) : null}
            {exibirReset ? (
              <button type="button" className="mapa-controlador-info-reset-btn" onClick={onReset}>
                Reset
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export function renderMarcadoresControlador({
  controladores,
  markerAberto,
  onAbrir,
  onFechar,
  onDetalhes,
  onReset,
  impactoPorControladorId,
}) {
  if (!controladores || !controladores.length) return null;

  return controladores.map(c => {
    const lat = Number(c.latitude);
    const lng = Number(c.longitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    const id = chaveMarcadorControlador(c);
    const impacto = impactoDoControlador(impactoPorControladorId, c);

    return (
      <Marker
        key={id}
        position={{ lat, lng }}
        icon={iconeMarcadorControlador(c)}
        onClick={() => onAbrir(id)}
        zIndex={impacto && impacto.impacto ? 4 : 2}
      >
        {markerAberto === id ? (
          <InfoWindow onCloseClick={onFechar}>
            <MapaControladorInfoWindow
              controlador={c}
              onDetalhes={onDetalhes ? () => onDetalhes(c) : null}
              onReset={onReset ? () => onReset(c) : null}
            />
          </InfoWindow>
        ) : null}
      </Marker>
    );
  });
}
